module.exports = __webpack_public_path__ + "img/ss08.0e8da878.jpg";